import { render, staticRenderFns } from "./unsubscribe.html?vue&type=template&id=25afecea&scoped=true&external"
import script from "./unsubscribe.js?vue&type=script&lang=js&external"
export * from "./unsubscribe.js?vue&type=script&lang=js&external"
import style0 from "./unsubscribe.scss?vue&type=style&index=0&id=25afecea&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25afecea",
  null
  
)

export default component.exports